import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '🌱',
    title: 'pages.quizOnboarding.howLongWanted.answer1',
    value: 'very_recently',
  },
  {
    emoji: '📅',
    title: 'pages.quizOnboarding.howLongWanted.answer2',
    value: 'last_year',
  },
  {
    emoji: '🗓️',
    title: 'pages.quizOnboarding.howLongWanted.answer3',
    value: 'last_few_years',
  },
  {
    emoji: '⏳',
    title: 'pages.quizOnboarding.howLongWanted.answer4',
    value: 'very_long_time',
  },
]

export default function HowLongWantedPage() {
  const language = useSelectedLanguageName()

  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.howLongWanted.title"
      translationInterpolation={{ language }}
    />
  )
}
